<template>
  <div class="package-info">
    <h1>套餐信息</h1>
    <el-row :gutter="20">
      <el-col :span="10">
        <label>会员类型</label>
        <span>{{ orderDetail.packageShowName }}</span>
        <span>{{ orderDetail.packageDescription }}</span>
      </el-col>
      <el-col :span="10">
        <label>应用渠道</label>
        <span>
          {{ orderDetail.packageChannel && orderDetail.packageChannel.join('、') }}
        </span>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="10">
        <label>咨询方式</label>
        {{ orderDetail.packageAdvisoryType && orderDetail.packageAdvisoryType.join('、') }}
      </el-col>
      <el-col :span="10">
        <label>套餐期限</label>
        <span>{{ orderDetail.packageLimitTime }}</span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'packageInfo',
  props: {
    orderDetail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.package-info {
  margin-bottom: 24px;
}
h1 {
  font-size: 18px;
  font-weight: 600;
  color: #262626;
  padding: 12px 0 10px 0;
}
.el-row {
  padding: 8px 0;
  .el-col {
    display: flex;
    color: #595959;
    line-height: 22px;
    font-size: 14px;
    label {
      display: block;
      margin-right: 12px;
      min-width: 70px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}
</style>
